import {Snackbar as SnackbarUI, styled} from '@mui/material';
import PropTypes from 'prop-types';
import React, {memo, useEffect, useState} from 'react';

const Snackbar = styled(SnackbarUI)(({theme}) => ({
  position: 'absolute',
  '& .MuiSnackbarContent-root': {
    backgroundColor: theme.vars.palette.primary.main,
  },
  '& .MuiSnackbarContent-message': {
    textAlign: 'center',
    width: '100%',
  },
}));

const MESSAGE_ONE =
  'At this zoom level it may take a while for your data to load.';

const MESSAGE_TWO = "It's still loading...";

const SoMuchLoading = ({loading}) => {
  const [message, setMessage] = useState(true);
  const [open, setOpen] = useState(false);

  useEffect(() => {
    let timeout;
    if (loading) {
      timeout = setTimeout(() => {
        setOpen(true);
      }, 5000);
    } else {
      setOpen(false);
      setMessage(true);
    }

    return () => clearTimeout(timeout);
  }, [loading]);

  useEffect(() => {
    let timer;
    if (loading) {
      timer = setInterval(() => {
        setMessage(!message);
      }, 20000);
    } else {
      setMessage(true);
    }

    return () => clearInterval(timer);
  }, [message, loading]);

  return (
    <Snackbar
      open={loading && open}
      anchorOrigin={{
        vertical: 'top',
        horizontal: 'center',
      }}
      message={message ? MESSAGE_ONE : MESSAGE_TWO}
    />
  );
};

SoMuchLoading.propTypes = {
  loading: PropTypes.bool,
};

export default memo(SoMuchLoading);
